import React, { FC } from "react";

interface alsoCompareType {
    toComp: string;
    indexNo: number;
}

const AlsoCompare: FC<alsoCompareType> = ({ indexNo }) => {
    const alsoComp = [
        { name: "Verloop.io", imgsrc: "comparison-page/verloop.png", anchor: "/verloop-alternative", normalName: "Verloop" },
        { name: "Interakt.io", imgsrc: "comparison-page/interakt.png", anchor: "/compare/interakt", normalName: "Interakt" },
        { name: "Wati.io", imgsrc: "comparison-page/wati.png", anchor: "/compare/wati", normalName: "Wati" },
        { name: "Zoko.io", imgsrc: "comparison-page/zoko.png", anchor: "/zoko-alternative", normalName: "Zoko" },
        { name: "Infobip.io", imgsrc: "comparison-page/infobip.png", anchor: "/infobip-alternative", normalName: "Infobip" },
    ];
    // const toShow = (indexNo: number) => {
    //     if (indexNo === (1 || 2)) {
    //         console.log("show", alsoComp.splice(indexNo, 3));
    //         return alsoComp.splice(indexNo, 3);
    //     } else {
    //         const temp = alsoComp.splice(indexNo);
    //         let i = 0;
    //         while (temp.length < 3) {
    //             temp.push(alsoComp[i]);
    //             i++;
    //         }
    //         console.log("show", temp);
    //         return temp;
    //     }
    // };
    function toShow(index: number) {
        const list = [];
        for (let i = 0, j = index; i < 3; i++, j++) {
            if (j === alsoComp.length - 1 || j > alsoComp?.length - 1) {
                list?.push(alsoComp[Math.abs(alsoComp?.length - j - 1)]);
            } else {
                list?.push(alsoComp[j + 1]);
            }
        }
        return list;
    }
    // console.log("show", toShow( indexNo));

    return (
        <>
            <h2 className="py-10 text-center text-white">Also Compare </h2>
            <div className="flex flex-wrap justify-center gap-3">
                {toShow(indexNo).map((d) => {
                    return (
                        <div key={d.name} className="bg-white inline-block rounded-md relative" style={{ width: "100%", maxWidth: "380px" }}>
                            <div className="p-2">
                                <img className="mx-auto" src={d.imgsrc} alt={`${d.normalName} image`} />
                            </div>
                            <p className="px-2 my-2.5 pl-6 text-xl text-gray-700 font-bold">Compare {d.normalName} with Gallabox</p>
                            <p className="px-2 mb-10 pl-6 text-gray-600 md:pr-3">Increase your funnel conversion by implementing... </p>
                            <div className="absolute right-5 bottom-4">
                                <a className="text-gray-700" href={d.anchor}>
                                    Read more <img className="inline-block" src="arrow.svg" alt="read more link" />
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default AlsoCompare;
